import { create } from 'zustand'
import { ThemeColors } from '../types'

export const generateTheme = (type: 'light' | 'dark'): Omit<ThemeColors, 'name'> => {
    if (type === 'light') {
        return {
            background: '#FFFFFF',
            text: '#272727',
            black: '#000000',
            white: '#FFFFFF',
            gray: '#a3a3a3',
            light: '#0b0e14',
            dark: '#040508',
            primary: '#34d399',
            secondary: '#38bdf8',
            tertiary: '#5D412C',
            accent: '#10b981',
            success: '#34d399',
            warning: '#FFB538',
            error: '#FA6060',
            info: '#38bdf8',
            disabled: '#4b5563',
            textSecondary: '#666666',
            textTertiary: '#111111',
            surface: '#F8F8FF',
            border: '#E5E7EB',
            profile: {
                description: {
                    background: '#0b0e14',
                    text: '#f8fafc'
                }
            },
            sideMenu: {
                background: '#040508',
                item: '#07090e',
                text: '#f8fafc'
            }
        }
    } else {
        return {
            background: '#07090e',
            text: '#f8fafc',
            black: '#000000',
            white: '#FFFFFF',
            gray: '#a3a3a3',
            light: '#0b0e14',
            dark: '#040508',
            primary: '#34d399',
            secondary: '#38bdf8',
            tertiary: '#5D412C',
            accent: '#10b981',
            success: '#34d399',
            warning: '#FFB538',
            error: '#FA6060',
            info: '#38bdf8',
            disabled: '#4b5563',
            textSecondary: '#a3a3a3',
            textTertiary: '#f8fafc',
            surface: '#0b0e14',
            border: '#040508',
            profile: {
                description: {
                    background: '#0b0e14',
                    text: '#f8fafc'
                }
            },
            sideMenu: {
                background: '#040508',
                item: '#07090e',
                text: '#f8fafc'
            }
        }
    }
}

interface ThemeStore {
    theme: 'light' | 'dark'
    colors: Omit<ThemeColors, 'name'>
    toggleTheme: () => void
    setTheme: (theme: 'light' | 'dark') => void
}

export const useThemeStore = create<ThemeStore>((set) => ({
    theme: 'dark',
    colors: generateTheme('dark'),
    toggleTheme: () => set((state) => {
        const newTheme = state.theme === 'light' ? 'dark' : 'light'
        return {
            theme: newTheme,
            colors: generateTheme(newTheme)
        }
    }),
    setTheme: (theme) => set({
        theme,
        colors: generateTheme(theme)
    })
}))
